module.exports = __webpack_public_path__ + "static/media/Background-1Beta.3331ac69.jpg";